import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

/**
 * Line-drawn object that floats in the hero — the single focal artifact on the page.
 */
export function LighterObject() {
  const reduceMotion = useReducedMotion();
  return <motion.div className="relative w-[220px] sm:w-[280px]" initial={reduceMotion ? undefined : {
    opacity: 0,
    y: 24
  }} animate={reduceMotion ? undefined : {
    opacity: 1,
    y: [0, -10, 0],
    rotate: [-7, -4, -7]
  }} transition={reduceMotion ? undefined : {
    opacity: {
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    },
    y: {
      duration: 7,
      repeat: Infinity,
      ease: 'linear'
    },
    rotate: {
      duration: 11,
      repeat: Infinity,
      ease: 'linear'
    }
  }} data-id="element-51" data-mp="2mzrsydhicnj4">
      <svg viewBox="0 0 200 260" className="w-full drop-shadow-[0_24px_40px_rgba(11,11,12,0.08)]" role="img" aria-label="Line illustration of a metal lighter" data-id="element-52" data-mp="1ubw1poapjntq">
        <g fill="#fcfcfd" stroke="#0b0b0c" strokeWidth="1.6" strokeLinejoin="round" data-id="element-53" data-mp="1gdgj1dc34coj">
          <path d="M40 88 L100 60 L160 88 L160 210 L100 240 L40 210 Z" data-id="element-54" data-mp="1l589zoz5kkf7" />
          <path d="M40 88 L100 118 L160 88" data-id="element-55" data-mp="17dts5lgzep9q" />
          <path d="M100 118 L100 240" stroke="#0b0b0c" strokeOpacity="0.35" data-id="element-56" data-mp="17ev7i2515xx9" />
          <path d="M40 40 L100 12 L160 40 L160 88 L100 118 L40 88 Z" data-id="element-57" data-mp="1cbvdkd1vr0od" />
          <path d="M40 40 L100 70 L160 40" data-id="element-58" data-mp="20292vvt2ylf9" />
          <path d="M100 70 L100 118" stroke="#0b0b0c" strokeOpacity="0.35" data-id="element-59" data-mp="203k71wqftv6w" />
          <path d="M46 132 L58 126 L58 146 L46 152 Z" data-id="element-60" data-mp="24444z2iu52u3" />
        </g>
        <g stroke="#0b0b0c" strokeOpacity="0.18" strokeWidth="1.2" data-id="element-61" data-mp="1q41rdshk8vkn">
          <path d="M104 126 L154 102" data-id="element-62" data-mp="1q3tcxw5shi7c" />
          <path d="M104 146 L154 122" data-id="element-63" data-mp="1v2w6okgbk200" />
          <path d="M104 166 L154 142" data-id="element-64" data-mp="1v1uv8eve5dhr" />
        </g>
      </svg>
      <div aria-hidden="true" className="mx-auto mt-6 h-px w-40 bg-gradient-to-r from-transparent via-hairline to-transparent" data-id="element-65" data-mp="ep61199jx5o9" />
    </motion.div>;
}